import {
  Box,
  Button,
  Step,
  StepLabel,
  Stepper,
  type SxProps,
  type Theme,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link as RouterLink } from "react-router-dom";

export const WIZARD_STEPS = ["Select evidence", "Configure report"] as const;

export interface WizardStepperProps {
  activeStep: 0 | 1;
  /** Renders the explicit Back button in the same row. Backward movement is
   *  only ever through this button — the steps themselves aren't clickable
   *  (jumping forward has no defined semantics in this wizard). */
  back?: { label: string; to: string };
  sx?: SxProps<Theme>;
}

/**
 * The report wizard's progress row: evidence selection → report setup. After
 * the report is configured and submitted, generation and review/sign happen
 * out of band (tracked from My Reports), so they're no longer guided steps.
 * Mounted at the top of each wizard page's content container (the app bar is
 * owned by usePageHeader).
 */
export function WizardStepper({ activeStep, back, sx }: WizardStepperProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        mb: 3,
        ...sx,
      }}
    >
      {back && (
        <Button
          component={RouterLink}
          to={back.to}
          startIcon={<ArrowBackIcon />}
          color="inherit"
          sx={{ flexShrink: 0, color: "text.secondary" }}
        >
          {back.label}
        </Button>
      )}
      <Stepper activeStep={activeStep} alternativeLabel sx={{ flexGrow: 1 }}>
        {WIZARD_STEPS.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
